import {type Configuration} from "../types";

export const addFailedText = "Adding configuration failed.";
export const addFailedUnauthorizedText = "Adding configuration failed. Unauthorized user.";
export const addSuccessText = "New configuration added.";

export const defaultValues: Configuration = {
  name: undefined,
  description: undefined,
  file: undefined,
  id: undefined,
  lastUpdate: undefined,
  typeGroupPairs: undefined
};
